<div class="table-wrapper">
  <div class="wizard-step-header">
    <h1 class="wizard-step-title">Results Configurator - {{localeName}}</h1>
    <p class="wizard-step-subtitle">Only checked items will be shown in search results</p>
  </div>
  <table mat-table [dataSource]="items" class="mat-elevation-z8">

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? updateShowInResultsSetting(row) : null"
                      [checked]="row.showInResults !== false"
                      [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
        <label [class.success-label]="row.showInResultsUpdateStatus === successStatus" [class.error-label]="row.showInResultsUpdateStatus === errorStatus">{{row.showInResultsUpdateStatus}}</label>
      </td>
    </ng-container>

    <ng-container matColumnDef="productDescShort">
      <th mat-header-cell *matHeaderCellDef> Device Desc. </th>
      <td mat-cell *matCellDef="let element"> {{element.productDescShort}} </td>
    </ng-container>

    <ng-container matColumnDef="materialID">
      <th mat-header-cell *matHeaderCellDef> Material ID </th>
      <td mat-cell *matCellDef="let element"> {{element.materialID}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>

